import React, { useState } from "react";
import { useGlobalController, BCMSRecord, BCMSDate } from "bcms-react";
import { NotificationHistory, ContactInfo } from "model";

import { CenterContentContainer, PageContainer, PageContentView } from "components/shared";
import UINotifiHeader from "components/shared/notifi/UINotifiHeader";
import UINotifiSearch from "components/shared/notifi/UINotifiSearch";
import NotificationsHistoryMonthContainer, { NotificationsHistoryWidget } from "./components";

import "./styles.css";

/**
 * @function NotificationsHistoryPage
 * @param {STRING} month - the month that the notifications were altered
 * @param {DOUBLE} year - the year that the notifications were altered
 * @param {DOUBLE} day - the year that the notifications were altered
 * @param {STRING} time - this is the time of the day that the modification was made to the alert
 * @param {STRING} icon - the icon next to the contact info that was changed
 * @param {STRING} contactInfo - the phone number or email that was changed for the alert
 * @param {STRING} message - the message that shows the user what modification was done to the alert
 * @return {React.Component}
 * @exported true
 * @description The main component for NotificationsHistoryPage
 */
export default function NotificationsHistoryPage(props) {
  // Initalize the global controller
  const controller = useGlobalController();
  BCMSRecord.globalControllerFor([ ContactInfo, NotificationHistory ], controller);
  // Get all the notification history and set that as the state
  const history = NotificationHistory.initAll();  
  const [ state, setState ] = useState(history);
  // Based on the value passed, filter the notification items based on the name
  const filterHistory = value => setState(history.filter(item => item.name.toLowerCase().indexOf(value.toLowerCase()) !== -1, []));
  // Sort the items by date, then reduce filtering them into different months if there are dates in different months
  const historyItems = state.sort((a, b) => {
      if(a.date.isAfter(b.date)) { return -1; }
      else if(a.date.isBefore(b.date)) { return 1; }
      else { return 0; } 
    }).reduce((result, item) => {
      const month = BCMSDate.init(item.date).setToFirst().format("m/d/Y");
      return { ...result, [ month ] : result[month] === undefined ? [item] : [ ...result[month], item ] };
    }, {});
  // For each month create a new month container and set the history items for the month
  const months = Object.keys(historyItems).map((key, index) => {
    const date = BCMSDate.init(new Date(key));
    const items = historyItems[key].map(item => <NotificationsHistoryWidget key={ `History_${ item.id }` } item={ item } />, []);
  
    return (
      <NotificationsHistoryMonthContainer 
        key={ `Month_${ key }` } 
        month={ date.format("F") } 
        year={ date.format("Y") }
        dataPoint={ `Notifications_History_Month_${ index }` }
      >
        { items }
      </NotificationsHistoryMonthContainer>
    );
  }, []);

  return(
    <PageContainer className="notifications-history-page">
      <PageContentView>
        <div className="notifications-page-container">
          <CenterContentContainer>
            <UINotifiHeader headerText="Notifications History">
              <UINotifiSearch placeHolder="Search" onChange={ filterHistory } dataPoint="Notifications_History_Search" />
            </UINotifiHeader>
            
            { months }
          </CenterContentContainer>
        </div>
      </PageContentView>
    </PageContainer>
  );
}